export const formFields = [
  {
    section: "Details",
    name: "ps3PatientPaySchName",
    label: "Schedule",
    fieldLabel: "PS3 Patient Pay Sch Name",
    type: "text",
    options: {
      required: { value: true, message: "REQUIRED" },
      maxLength: { value: 10, message: "MAXLENGTH_10" },
    },
    fieldNature: "Add: Editable, Change: Read-only, View: Read-only",
    position: [1, 1],
  },
  {
    section: "Details",
    name: "ps3PatientPaySchDesc",
    label: "Description",
    fieldLabel: "PS3 Patient Pay Sch Desc",
    type: "text",
    options: {
      required: { value: true, message: "REQUIRED" },
      maxLength: { value: 25, message: "MAXLENGTH_25" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [2, 1],
  },
  {
    section: "Details",
    name: "ps3PlanUseQualifier",
    label: "Plan Use Qualifier",
    fieldLabel: "PS3 Plan Use Qualifier",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: { maxLength: { value: 1, message: "MAXLENGTH_1" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [3, 1],
  },
  {
    section: "Details",
    name: "hiddenRecordIndicator",
    label: "Display",
    fieldLabel: "ADX Display Record",
    type: "dropdown",
    dropdownCondition: "Valid Values",
    options: { maxLength: { value: 1, message: "MAXLENGTH_1" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [4, 1],
  },
  {
    section: "Audit Fields",
    name: "addDate",
    label: "Added",
    fieldLabel: "ADD Date",
    type: "date",
    format: "MM/DD/YY",
    fieldNature: "Add: Non-Display, Change: Read-only, View: Read-only",
    position: [20, 14],
  },
  {
    section: "Audit Fields",
    name: "chgDate",
    label: "Changed",
    fieldLabel: "CHG Date",
    type: "date",
    format: "MM/DD/YY",
    fieldNature: "Add: Non-Display, Change: Read-only, View: Read-only",
    position: [20, 32],
  },
  {
    section: "Audit Fields",
    name: "chgUserName",
    label: "User",
    fieldLabel: "CHG User Name",
    type: "text",
    options: { maxLength: { value: 10, message: "MAXLENGTH_10" } },
    fieldNature: "Add: Non-Display, Change: Read-only, View: Read-only",
    position: [20, 57],
  },
  {
    section: "Audit Fields",
    name: "noteExistenceStatus",
    label: "Notes Exist",
    fieldLabel: "Note Values",
    type: "dropdown",
    dropdownCondition: "Yes or No",
    options: { maxLength: { value: 1, message: "MAXLENGTH_1" } },
    fieldNature: "Add: Non-Display, Change: Read-only, View: Read-only",
    position: [20, 79],
  },
];
